import { CompanyGroupModel, ICompanyGroupModel } from "./company-group-model";
import { IPrimary_Branch, Primary_Branch } from "./primary-branch";
import { User_Tax_Identifiers } from "./tax-identifiers";

export interface KycStatusModel {
    id: string;
    updated_at: string;
    created_at: string;
    is_active: boolean;
    name: string;
    name_kyc: string;
    description: string;
    edit_allowed_internal: boolean;
    edit_allowed_external: boolean;
    dev_name: string;
    sequence: number;
    created_by?: any;
    updated_by?: any;
}

export interface ICompanyModel {
    id?: string;
    group?: ICompanyGroupModel;
    primary_branch?: IPrimary_Branch;
    secondary_branches?: Array<IPrimary_Branch>
    tax_identifiers?: Array<User_Tax_Identifiers>;
    updated_at?: Date;
    created_at?: Date;
    is_active?: boolean;
    name?: string;
    website?: string;
    legal_name?: string;
    trade_name?: string;
    is_sez?: boolean;
    credit_days?: number;
    credit_limits_currency?: string;
    credit_limits?: number;
    virtual_account?: string;
    bank_name?: string;
    address?: string;
    about?: string;
    data_audit_status?: string;
    data_audit_done_on?: Date;
    primary_contact_no?: string;
    secondary_contact_no?: string;
    primary_email?: string;
    secondary_email?: string;
    created_by?: string;
    updated_by?: string;
    company_type?: any;
    industry_type?: any;
    state?: any;
    data_audit_done_by?: string;
    logo?: string;
    documents?: any;
    remarks?: string;
    country?: any;
    kyc_status?: KycStatusModel;
    master_agreement_no?: string;
    master_agreement_valid_till?: Date;
    master_agreement_document?: any;
    cover_picture?: any;
    constitution: any;
    is_b2c: boolean;
    default_currency:string;
    max_teu_allocation:number;
}

export interface ICompanyErrors {
    id: string[]
    group: string[]
    primary_branch: string[]
    secondary_branches: string[]
    tax_identifiers: string[]
    updated_at: string[]
    created_at: string[]
    is_active: string[]
    name: string[]
    website: string[]
    legal_name: string[]
    trade_name: string[]
    is_sez: string[]
    credit_days: string[]
    credit_limits_currency: string[]
    credit_limits: string[]
    virtual_account: string[]
    bank_name: string[]
    address: string[]
    about: string[]
    data_audit_status: string[]
    data_audit_done_on: string[]
    primary_contact_no: string[]
    secondary_contact_no: string[]
    primary_email: string[]
    secondary_email: string[]
    created_by: string[]
    updated_by: string[]
    company_type: string[]
    industry_type: string[]
    state: string[]
    data_audit_done_by: string[]
    logo: string[]
    documents: string[]
    remarks: string[]
    country: string[]
    master_agreement_no: string[];
    master_agreement_valid_till: string[];
    master_agreement_document: string[];
    cover_picture: string[];
    constitution: string[];
    is_b2c: string[];
    default_currency:string[];
    max_teu_allocation:string[];
}

export class CompanyModel {
    id?: string;
    group?: CompanyGroupModel;
    primary_branch?: Primary_Branch;
    secondary_branches?: Primary_Branch[];
    tax_identifiers?: User_Tax_Identifiers[];
    updated_at?: Date;
    created_at?: Date;
    is_active?: boolean;
    name?: string;
    website?: string;
    legal_name?: string;
    trade_name?: string;
    is_sez?: boolean;
    credit_days?: number;
    credit_limits_currency?: string;
    credit_limits?: number;
    virtual_account?: string;
    bank_name?: string;
    address?: string;
    about?: string;
    data_audit_status?: string;
    data_audit_done_on?: Date;
    primary_contact_no?: any;
    secondary_contact_no?: any;
    primary_email?: string;
    secondary_email?: string;
    created_by?: string;
    updated_by?: string;
    company_type?: any;
    industry_type?: any;
    state?: any;
    data_audit_done_by?: string;
    logo?: any;
    documents?: any;
    remarks?: string;
    country?: any;
    kyc_status?: KycStatusModel;
    master_agreement_no?: string;
    master_agreement_valid_till?: Date;
    master_agreement_document?: any;
    cover_picture?: any;
    constitution: any;
    is_b2c:boolean;
    default_currency:string;
    max_teu_allocation:number;

    error: ICompanyErrors;

    constructor() {
        this.id = null;
        this.group = new CompanyGroupModel();
        this.primary_branch = new Primary_Branch();
        this.secondary_branches = [];
        this.tax_identifiers = [new User_Tax_Identifiers()];
        this.updated_at = null;
        this.created_at = null;
        this.is_active = true;
        this.name = null;
        this.website = null;
        this.legal_name = null;
        this.trade_name = null;
        this.is_sez = false;
        this.credit_days = null;
        this.credit_limits_currency = 'USD';
        this.credit_limits = null;
        this.virtual_account = null;
        this.bank_name = null;
        this.address = null;
        this.about = null;
        this.data_audit_status = null;
        this.data_audit_done_on = null;
        this.primary_contact_no = null;
        this.secondary_contact_no = null;
        this.primary_email = null;
        this.secondary_email = null;
        this.created_by = null;
        this.updated_by = null;
        this.company_type = null;
        this.industry_type = null;
        this.state = null;
        this.data_audit_done_by = null;
        this.logo = null;
        this.documents = [];
        this.remarks = null;
        this.country = null;
        this.master_agreement_no = null;
        this.master_agreement_valid_till = null;
        this.master_agreement_document = null;
        this.cover_picture = null;
        this.constitution = null;
        this.is_b2c = false;
        this.default_currency = null
        this.max_teu_allocation = null;
        this.resetErrors();
    }

    resetErrors() {
        this.error = {
            id: [],
            group: [],
            primary_branch: [],
            secondary_branches: [],
            tax_identifiers: [],
            updated_at: [],
            created_at: [],
            is_active: [],
            name: [],
            website: [],
            legal_name: [],
            trade_name: [],
            is_sez: [],
            credit_days: [],
            credit_limits_currency: [],
            credit_limits: [],
            virtual_account: [],
            bank_name: [],
            address: [],
            about: [],
            data_audit_status: [],
            data_audit_done_on: [],
            primary_contact_no: [],
            secondary_contact_no: [],
            primary_email: [],
            secondary_email: [],
            created_by: [],
            updated_by: [],
            company_type: [],
            industry_type: [],
            state: [],
            data_audit_done_by: [],
            logo: [],
            documents: [],
            remarks: [],
            country: [],
            master_agreement_no: [],
            master_agreement_valid_till: [],
            master_agreement_document: [],
            cover_picture: [],
            constitution: [],
            is_b2c: [],
            default_currency:[],
            max_teu_allocation:[],

        }
    }

    savePayloadToModel(data) {
        this.id = data.id;
        this.group = data.group;
        this.primary_branch = data.primary_branch == null ? new Primary_Branch() : data.primary_branch;
        this.secondary_branches = [...data.secondary_branches];
        this.updated_at = data.updated_at;
        this.created_at = data.created_at;
        this.is_active = data.is_active;
        this.name = data.name;
        this.website = data.website;
        this.legal_name = data.legal_name;
        this.trade_name = data.trade_name;
        this.is_sez = data.is_sez;
        this.credit_days = data.credit_days;
        this.credit_limits_currency = data.credit_limits_currency;
        this.credit_limits = data.credit_limits;
        this.virtual_account = data.virtual_account;
        this.bank_name = data.bank_name;
        this.address = data.address;
        this.about = data.about;
        this.data_audit_status = data.data_audit_status;
        this.data_audit_done_on = data.data_audit_done_on;
        this.primary_contact_no = data.primary_contact_no;
        this.secondary_contact_no = data.secondary_contact_no;
        this.primary_email = data.primary_email;
        this.secondary_email = data.secondary_email;
        this.created_by = data.created_by;
        this.updated_by = data.updated_by;
        this.company_type = data.company_type;
        this.industry_type = data.industry_type;
        this.state = data.state;
        this.data_audit_done_by = data.data_audit_done_by;
        this.logo = data.logo;
        this.documents = [...data.documents];
        this.remarks = data.remarks;
        this.country = data.country;
        this.kyc_status = data.kyc_status;
        this.master_agreement_no = data.master_agreement_no;
        this.master_agreement_valid_till = data.master_agreement_valid_till;
        this.master_agreement_document = data.master_agreement_document;
        this.cover_picture = data.cover_picture;
        this.constitution = data.constitution;
        this.is_b2c = data.is_b2c;
        this.tax_identifiers = [];
        this.default_currency =data.default_currency;
        this.max_teu_allocation = data.max_teu_allocation;

        for (let i = 0; i < data.tax_identifiers.length; i++) {
            this.tax_identifiers[i] = new User_Tax_Identifiers();
            this.tax_identifiers[i].savePayloadToModel(data.tax_identifiers[i]);
        }
    }

    saveGSTPayload(data, idx) {
        this.legal_name = data.trade_name;
        this.trade_name = data.trade_name;
        this.state = data.state;
        this.primary_branch.address = data.address[idx].full_address;
        this.primary_branch.pincode = data.address[idx].pncd
    }

    saveGSTSecondaryBranches(data, idx) {
        this.secondary_branches[idx] = new Primary_Branch;
        this.secondary_branches[idx].address = data.address[idx].full_address;
        this.secondary_branches[idx].pincode = data.address[idx].pncd
    }

    getSavePayload() {
        return {
            group: this.group,
            primary_branch: {
                address: this.primary_branch?.address,
                pincode: this.primary_branch?.pincode,
                city: typeof this.primary_branch?.city == 'object' && this.primary_branch?.city != null ? this.primary_branch?.city?.id : this.primary_branch?.city,
            },
            secondary_branches: this.secondary_branches.map((item) => {
                return {
                    address: item.address,
                    pincode: item.pincode,
                    city: typeof item.city == 'object' && item.city != null ? item.city.id : item.city,
                }
            }),
            tax_identifiers: this.tax_identifiers.filter(item => item != null).map((item) => item.getSavePayload()),
            is_active: this.is_active,
            name: this.name,
            website: this.website,
            legal_name: this.legal_name,
            trade_name: this.trade_name,
            is_sez: this.is_sez,
            credit_days: this.credit_days,
            credit_limits_currency: this.credit_limits_currency,
            credit_limits: this.credit_limits,
            virtual_account: this.virtual_account,
            bank_name: this.bank_name,
            address: this.address,
            about: this.about,
            data_audit_status: this.data_audit_status,
            data_audit_done_on: this.data_audit_done_on,
            primary_contact_no: typeof this.primary_contact_no == 'object' && this.primary_contact_no != null ? this.primary_contact_no.as_e164 : this.primary_contact_no,
            secondary_contact_no: typeof this.secondary_contact_no == 'object' && this.secondary_contact_no != null ? this.secondary_contact_no.as_e164 : this.secondary_contact_no,
            primary_email: this.primary_email,
            secondary_email: this.secondary_email,
            company_type: typeof this.company_type == 'object' && this.company_type != null ? this.company_type.id : this.company_type,
            industry_type: typeof this.industry_type == 'object' && this.industry_type != null ? this.industry_type.id : this.industry_type,
            state: typeof this.state == 'object' && this.state != null ? this.state.id : this.state,
            data_audit_done_by: this.data_audit_done_by,
            logo: typeof this.logo == 'object' && this.logo != null ? this.logo.id : this.logo,
            cover_picture: typeof this.cover_picture == 'object' && this.cover_picture != null ? this.cover_picture.id : this.cover_picture,
            documents: this.documents.map((item) => item.id),
            remarks: this.remarks,
            country: typeof this.country == 'object' && this.country != null ? this.country.id : this.country,
            constitution: typeof this.constitution == 'object' && this.constitution != null ? this.constitution.id : this.constitution,
            is_b2c: this.is_b2c,
            default_currency:this.default_currency,
            max_teu_allocation:this.max_teu_allocation,
        }
    }

    getAgreementPayload() {
        return {
            master_agreement_no: this.master_agreement_no,
            master_agreement_valid_till: this.master_agreement_valid_till,
            master_agreement_document: typeof this.master_agreement_document == 'object' && this.master_agreement_document != null ? this.master_agreement_document.id : this.master_agreement_document,
        }
    }

    savePayloadToModelForProfile(data) {
        this.id = data.id;
        this.group = data.group;
        this.primary_branch = data.primary_branch;
        this.secondary_branches = [...data.secondary_branches];
        this.updated_at = data.updated_at;
        this.created_at = data.created_at;
        this.is_active = data.is_active;
        this.name = data.name;
        this.website = data.website;
        this.legal_name = data.legal_name;
        this.trade_name = data.trade_name;
        this.is_sez = data.is_sez;
        this.credit_days = data.credit_days;
        this.credit_limits_currency = data.credit_limits_currency;
        this.credit_limits = data.credit_limits;
        this.virtual_account = data.virtual_account;
        this.bank_name = data.bank_name;
        this.address = data.address;
        this.about = data.about;
        this.data_audit_status = data.data_audit_status;
        this.data_audit_done_on = data.data_audit_done_on;
        this.primary_contact_no = data.primary_contact_no;
        this.secondary_contact_no = data.secondary_contact_no;
        this.primary_email = data.primary_email;
        this.secondary_email = data.secondary_email;
        this.created_by = data.created_by;
        this.updated_by = data.updated_by;
        this.company_type = data.company_type;
        this.industry_type = data.industry_type;
        this.state = data.state;
        this.data_audit_done_by = data.data_audit_done_by;
        this.logo = data.logo;
        this.documents = [...data.documents];
        this.remarks = data.remarks;
        this.country = data.country;
        this.kyc_status = data.kyc_status;
        this.master_agreement_no = data.master_agreement_no;
        this.master_agreement_valid_till = data.master_agreement_valid_till;
        this.master_agreement_document = data.master_agreement_document;
        this.cover_picture = data.cover_picture;
        this.constitution = data.constitution;
        this.is_b2c = data.is_b2c;
        this.tax_identifiers = [];
        this.default_currency = data.default_currency;
        this.max_teu_allocation = data.max_teu_allocation;

        for (let i = 0; i < data.tax_identifiers.length; i++) {
            this.tax_identifiers[i] = new User_Tax_Identifiers();
            this.tax_identifiers[i].savePayloadToModel(data.tax_identifiers[i]);
        }
    }

    getSavePayloadForProfile() {
        return {
            id: this.id,
            group: this.group,
            name: this.name,
            legal_name: this.legal_name,
            trade_name: this.trade_name,
            company_type: typeof this.company_type == 'object' && this.company_type != null ? this.company_type.id : this.company_type,
            industry_type: typeof this.industry_type == 'object' && this.industry_type != null ? this.industry_type.id : this.industry_type,
            state: typeof this.state == 'object' && this.state != null ? this.state.id : this.state,
            country: typeof this.country == 'object' && this.country != null ? this.country.id : this.country,
            constitution: typeof this.constitution == 'object' && this.constitution != null ? this.constitution.id : this.constitution,
        }
    }

    getContactSavePayloadForProfile() {
        return {
            id: this.id,
            website: this.website,
            primary_contact_no: typeof this.primary_contact_no == 'object' && this.primary_contact_no != null ? this.primary_contact_no.as_e164 : this.primary_contact_no,
            secondary_contact_no: typeof this.secondary_contact_no == 'object' && this.secondary_contact_no != null ? this.secondary_contact_no.as_e164 : this.secondary_contact_no,
            primary_email: this.primary_email,
            secondary_email: this.secondary_email,
        }
    }
}
